export const LIST_TYPES = {
  published: 'published',
  unpublished: 'unpublished',
}

export const ITEM_TYPES = {
  activity: 'activity',
  channel: 'channel',
}
